/* eslint-disable react/self-closing-comp */
import { FC } from 'react'

interface ViafouraTrayProps {
  floating: 'true' | 'false'
}

const ViafouraTray: FC<ViafouraTrayProps> = ({ floating }) => (
  <vf-tray-trigger floating={floating}></vf-tray-trigger>
)

export default ViafouraTray
